(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["our_brand"] && !Shopify.designMode) return;
  try {
     
  const our_athletes_carousel = document.querySelector(".carousel");
  if(our_athletes_carousel != null) {
        const flkty = new Flickity(our_athletes_carousel, {
          cellAlign: "left",
          contain: true,
          draggable: true,
          groupCells: true,
          pageDots: false
        });
  }

  } catch(e) { console.error(e); }
})();
})();
